import { render, staticRenderFns } from "./QnaSortingPicker.vue?vue&type=template&id=7678e427&lang=pug&"
import script from "./QnaSortingPicker.vue?vue&type=script&lang=ts&"
export * from "./QnaSortingPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports